import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { XCircle, ArrowLeft } from 'lucide-react';

const CheckoutCancel = () => {
  const { currentTheme } = useTheme();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-20 h-20 rounded-full mx-auto flex items-center justify-center bg-red-500/20">
          <XCircle className="w-10 h-10 text-red-400" />
        </div>
        
        <h1 className="text-4xl font-bold text-white">Payment Cancelled</h1>
        <p className="text-gray-400 text-lg">
          No worries — your cart is still waiting for you.
        </p>

        <div className="space-y-3 pt-4">
          <Link
            to="/beats"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-bold text-black transition-transform hover:scale-105"
            style={{ backgroundColor: currentTheme.primary }}
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Store
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
